<template>
  <appointment-coordination
    :coordinate-new-space="coordinateNewSpace"
    :get-appointment-info="getAppointmentInfo"
    :get-breach="getBreach"
    :get-centerby-user-id="getCenterbyUserId"
    :get-centers="getCenters"
    :get-contact-information="getContactInformation"
    :get-municipalities-by-discipline="getMunicipalitiesByDiscipline"
    :get-phone-providers="getPhoneProviders"
    :get-registration-date="getRegistrationDate"
    :get-relationships="getRelationships"
    :get-student-detail="getStudentDetail"
    :get-valid-appointment-disciplines="getValidAppointmentDisciplines"
    :has-active-coordinated-discipline-fn="hasActiveCoordinatedDisciplineFn"
    :has-permissions="hasPermissions"
    :load-validation-messages="loadValidationMessages"
    :save-appointment-coordinate="saveAppointmentCoordinate"
    :search-available-dates="searchAvailableDates"
    :user="user"
  />
</template>

<script>
import { mapState } from 'vuex';
import { AppointmentCoordination } from 'appointment-management';

import {
  getStudentDetail as _getStudentDetail,

  //available appointment services
  loadValidationMessages as _loadValidationMessages,
  searchAvailableDates as _searchAvailableDates,
  getValidAppointmentDisciplines as _getValidAppointmentDisciplines,
  hasActiveCoordinatedDiscipline as _hasActiveCoordinatedDiscipline,
  getMunicipalitiesByDiscipline as _getMunicipalitiesByDiscipline,
  getBreach as _getBreach,
  getRegistrationDate as _getRegistrationDate,

  //confirm appointment services
  getAppointmentInfo as _getAppointmentInfo,
  getRelationships as _getRelationships,
  getPhoneProviders as _getPhoneProviders,
  getContactInformation as _getContactInformation,
  getCenterbyUserId as _getCenterbyUserId,
  getCenters as _getCenters,
  saveAppointmentCoordinate as _saveAppointmentCoordinate,
} from '@/modules/shared/provider.api';

export default {
  name: 'AppointmentCoordinationWrapper',
  components: {
    AppointmentCoordination,
  },
  computed: {
    ...mapState('$_user', ['user']),
  },
  methods: {
    coordinateNewSpace(clientAppointmentId) {
      this.$router.push({
        path: `/provider/appointmentNewSpaceCoordination/${clientAppointmentId}`,
      });
    },
    hasPermissions(permission) {
      return this.userHasPermissions(permission);
    },
    getStudentDetail(studentSie) {
      return _getStudentDetail(studentSie);
    },

    //available appointment services
    loadValidationMessages(params) {
      return _loadValidationMessages(params);
    },
    searchAvailableDates(params) {
      return _searchAvailableDates(params);
    },
    getValidAppointmentDisciplines(serviceTypeId) {
      return _getValidAppointmentDisciplines(serviceTypeId);
    },
    hasActiveCoordinatedDisciplineFn(params) {
      return _hasActiveCoordinatedDiscipline(params);
    },
    getMunicipalitiesByDiscipline(params) {
      return _getMunicipalitiesByDiscipline(params);
    },
    getBreach(params) {
      return _getBreach(params);
    },
    getRegistrationDate(studentId) {
      return _getRegistrationDate(studentId);
    },

    //confirm appointment services
    getAppointmentInfo(clientAppointmentId) {
      return _getAppointmentInfo(clientAppointmentId);
    },
    getRelationships() {
      return _getRelationships();
    },
    getPhoneProviders() {
      return _getPhoneProviders();
    },
    getContactInformation(studentId) {
      return _getContactInformation(studentId);
    },
    getCenterbyUserId(sub) {
      return _getCenterbyUserId(sub);
    },
    getCenters(filters) {
      return _getCenters(filters);
    },
    saveAppointmentCoordinate(data) {
      return _saveAppointmentCoordinate(data);
    },
  },
};
</script>
